var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifierWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st4{display:inline;fill:none;stroke:#000000;stroke-width:0.9494;stroke-miterlimit:10;}\n\t.st5{display:inline;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,7.9V12h-5.1V7.9H15.9 M17,6.8H9.7v6.3H17V6.8L17,6.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.1,1.2c4.9,0,8.9,4,8.9,8.9S15,19,10.1,19s-8.9-4-8.9-8.9S5.2,1.2,10.1,1.2 M10.1,0.1c-5.5,0-10,4.5-10,10 s4.5,10,10,10s10-4.5,10-10S15.6,0.1,10.1,0.1L10.1,0.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1,27.1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.1,17.1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 8.1,
    y1: 3.1,
    x2: 8,
    y2: 17.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 11.1,
    y1: 3.1,
    x2: 11,
    y2: 17.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 10.1,
    cy: 10.1,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,5.1c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S7.3,5.1,10.1,5.1 M10.1,4.1c-3.3,0-6,2.7-6,6s2.7,6,6,6 s6-2.7,6-6S13.4,4.1,10.1,4.1L10.1,4.1z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 7.1,
    className: "st5",
    width: 6,
    height: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,27.5L27.5,27.5c-0.6,0.6-1.6,0.6-2.2,0l-10-10l2.2-2.2l10,10C28.2,25.9,28.2,26.9,27.5,27.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.8,27.8L27.8,27.8c-0.4,0.4-1.2,0.2-1.8-0.4l-10-10l1.4-1.4l10,10C28,26.6,28.2,27.4,27.8,27.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierWhite);
export default __webpack_public_path__ + "static/media/Magnifier-white.4accaeeff0e412935fef922dd2e8d050.svg";
export { ForwardRef as ReactComponent };